import type { FC } from 'react';
// import Icon, { type IconString } from '2-core-elements/Icon/Icon';
import Button, { type ButtonProps } from '2-core-elements/Buttons/Button';

type LinkSkin = '1' | '2';

export interface LinkCTAProps extends Omit<ButtonProps, 'prefixClass' | 'skin'> {
    skin?: LinkSkin;
}


const LinkCTA: FC<LinkCTAProps> = ({
    skin = '1',
    ...restProps
}) => {
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Button skin={skin} prefixClass="link" {...restProps} />
    );
};

export default LinkCTA;
